/**
 * ReportFutureStory — "Toivottu tulevaisuus" section.
 * Renders intro text + facilitator-editable description of what
 * participants imagined + AI-generated collective future story.
 *
 * MVP (V3.1): pure text fields. AI auto-generation deferred to v2 per
 * käsikirjoitus 2026-05 ("ei ole prio, tekstikenttä riittää").
 */
import React from 'react';
import { Section, SectionTitle, Paragraph } from './reportStyles';
import WorkshopAction from './WorkshopAction';
import EditableText from './EditableText';
import { useReportEdits } from './ReportEditsContext';
import { useTranslation } from '../../hooks/useTranslation.jsx';

export default function ReportFutureStory() {
  const { t } = useTranslation();
  const { get, editMode } = useReportEdits();
  // Hide the "Kollektiivinen tulevaisuustarina" subsection when the
  // facilitator hasn't written one. Check the actual content, not just
  // whether the field has been touched — saving an empty string (which
  // happens via the inline editor's blur-save) still creates a row, so
  // isEdited() alone would surface the placeholder. Admins in edit mode
  // always see the box so they can author the story.
  const story = (get('future-story.story', '') || '').trim();
  const showStoryBox = editMode || story.length > 0;

  return (
    <Section id="future-story">
      <SectionTitle>{t('report.futureStory.title')}</SectionTitle>
      <Paragraph>{t('report.futureStory.intro')}</Paragraph>
      <WorkshopAction>
        <EditableText
          fieldKey="future-story.what"
          fallback={t('report.futureStory.whatDefault')}
          label={t('report.futureStory.whatLabel')}
        />
      </WorkshopAction>
      {showStoryBox && (
        <div style={{ marginTop: 24, padding: '20px 24px', background: '#f5f5f5', borderLeft: '4px solid #000' }}>
          <div style={{ fontSize: '0.75rem', fontWeight: 600, color: '#367ABA', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 10 }}>
            {t('report.futureStory.storyTitle')}
          </div>
          <div style={{ fontSize: '1rem', lineHeight: 1.7, color: '#1a1a1a', fontStyle: 'italic' }}>
            <EditableText
              fieldKey="future-story.story"
              fallback={t('report.futureStory.storyHint')}
              label={t('report.futureStory.storyLabel')}
            />
          </div>
        </div>
      )}
    </Section>
  );
}
